import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class svgAspectRatio extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    const horizontalClass = 'aspectRatio--horizontal';
    const verticalClass = 'aspectRatio--vertical';
    const svg = this.element.children[0];
    const box = svg.viewBox.baseVal;
    if (undefined !== box) {
      const width = box.width;
      const height = box.height;
      if (parseInt(width, 10) > parseInt(height, 10)) {
        this.element.classList.add(horizontalClass);
      } else {
        this.element.classList.add(verticalClass);
      }
    }
  }
}
